import { render, staticRenderFns } from "./GGR.vue?vue&type=template&id=e21bc11c"
import script from "./GGR.vue?vue&type=script&lang=js"
export * from "./GGR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports